export default __webpack_public_path__ + "static/media/linkedin_logo_white.802de85d.svg";